import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, X } from "lucide-react";

export default function PrivacyBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show banner after 2 seconds
    const timer = setTimeout(() => setIsVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-auto md:w-[400px] z-[60]"
        >
          <div className="bg-[var(--glass-bg)] backdrop-blur-xl border border-[var(--glass-border)] p-4 rounded-2xl shadow-2xl flex gap-4 items-start relative overflow-hidden">
            
            {/* Green Pulse Effect */}
            <div className="absolute top-0 left-0 w-1 h-full bg-[var(--nily-teal)]" />
            
            <div className="mt-1 p-2 rounded-full bg-[var(--nily-teal)]/10 text-[var(--nily-teal)]">
              <ShieldCheck size={20} />
            </div>
            
            <div className="flex-1 space-y-1">
              <h4 className="text-sm font-bold text-[var(--text-main)]">Privacy Active</h4>
              <p className="text-xs text-[var(--text-muted)] leading-relaxed">
                No tracking cookies detected. Nily does not monetize your behavioral data. Your session is mathematically isolated.
              </p>
              <div className="pt-2 flex gap-4">
                <button 
                  onClick={() => setIsVisible(false)}
                  className="text-xs font-bold text-[var(--nily-teal)] hover:underline"
                >
                  Acknowledge
                </button>
                <a href="/privacy" className="text-xs text-[var(--text-muted)] hover:text-[var(--text-main)]">
                  Read Protocol
                </a>
              </div>
            </div>

            <button 
              onClick={() => setIsVisible(false)}
              className="text-[var(--text-muted)] hover:text-[var(--text-main)]"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
